import * as React from "react";

export interface CardProps {
  title: string;
  titleBackgroundColor?: string;
}

const Card: React.FC<CardProps> = props => {
  return (
    <div className="my-card">
      <h1
        className="my-title-card"
        style={{
          backgroundColor: `${props.titleBackgroundColor}`
        }}
      >
        {props.title}
      </h1>
      <div className="my-card-body">{props.children}</div>
    </div>
  );
};

Card.defaultProps = { titleBackgroundColor: "#70C1FF" };

export default Card;
